/**
 * Module dependencies.
 */

import { color } from 'styles/utils/colors';
import { css } from '@emotion/react';
import { ifProp } from 'styled-tools';
import { navBarHeight } from 'utils/constants';
import styled from '@emotion/styled';

/**
 * Export `NavbarWrapper` styled component.
 */

export const NavbarWrapper = styled.div`
  padding: 16px;
  height: ${navBarHeight}px;
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
  mix-blend-mode: difference;
  color: white;

  @media (max-width: 820px) {
    height: ${navBarHeight / 2}px;
    padding: 16px 0;
  }
`;

/**
 * Export `NavbarContent` styled component.
 */

export const NavbarContent = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;

  @media (max-width: 820px) {
    grid-template-columns: 1fr max-content;
  }
`;

/**
 * `LogoWrapper` styled component.
 */

export const LogoWrapper = styled.div`
  width: 260px;
  align-items: center;
  display: flex;

  @media (max-width: 1200px) {
    width: 220px;
  }

  @media (max-width: 992px) {
    width: 180px;
  }

  @media (max-width: 820px) {
    width: 150px;
  }

  @media (max-width: 576px) {
    width: 120px;
  }
`;

/**
 * Export `LogoWrapperLogo` styled component.
 */

export const LogoWrapperLogo = styled.div`
  position: fixed;
  z-index: 1000;
  opacity: 0.5;
`;

/**
 * Export `Logo` styled component.
 */

export const Logo = styled.span`
  color: ${color('gray200')};
  height: auto;
  max-width: 300px;
  width: 100%;
  top: 20px;

  @media (max-width: 1200px) {
    max-width: 250px;
  }

  @media (max-width: 992px) {
    max-width: 200px;
  }

  @media (max-width: 820px) {
    max-width: 130px;
  }

  @media (max-width: 576px) {
    max-width: 150px;
  }
`;

/**
 * Export `FlagIcon` styled component.
 */

export const FlagIcon = styled.img<{
  selected: boolean;
}>`
  height: 15px;
  border: 1px solid #ccc;
  margin-right: 8px;
  opacity: 0.4;
  cursor: pointer;

  ${ifProp(
    'selected',
    css`
      opacity: 1;
    `,
  )}
`;

/**
 * Export `LanguageSelector` styled component.
 */

export const LanguageSelector = styled.div`
  margin-left: 32px;
  margin-top: 3px;
  position: fixed;
  z-index: 1000;

  @media (max-width: 820px) {
    margin-top: 9px;
  }

  @media (max-width: 576px) {
    margin-top: 13px;
  }
`;
